/** Gluon API for the mobile factoring prompt's "No, I don't" link, `/v1/gluon/config/mobile-factoring-prompt`. */

import axios from 'axios'

interface Envelope<T> {
    success: boolean
    data: T
    message?: string
}

export const mobileFactoringPromptApi = {
    get: async (): Promise<string> =>
        (await axios.get<Envelope<{ noAnswerDeeplink: string }>>('/gluon/config/mobile-factoring-prompt')).data.data.noAnswerDeeplink,

    /** Returns the server's warning, e.g. when the linked promo page is not published yet. */
    save: async (noAnswerDeeplink: string): Promise<string | undefined> =>
        (await axios.put<Envelope<{ noAnswerDeeplink: string }>>('/gluon/config/mobile-factoring-prompt', { noAnswerDeeplink })).data.message,
}
